import React from 'react';
import { Post, getAssetUrl } from '../../lib/directus';
import { Calendar, Tag } from 'lucide-react';

interface BlogCardProps {
  post: Post;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  console.log('BlogCard post:', { id: post.id, publish_date: post.publish_date, published_at: post.published_at });
  return (
    <article className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      {post.cover && (
        <img
          src={getAssetUrl(post.cover) || undefined}
          alt={post.title}
          className="w-full h-48 object-cover"
        />
      )}
      <div className="p-6">
        <h3 className="text-xl font-bold text-burgundy mb-2">
          <a href={`/blog/${post.slug}`} className="hover:underline">
            {post.title}
          </a>
        </h3>
        <p className="text-gray-600 mb-4">{post.excerpt}</p>
        <div className="flex items-center text-sm text-gray-500">
          <Calendar className="w-4 h-4 mr-1" />
          <span>{new Date(post.publish_date).toLocaleDateString('ru-RU')}</span>
          {post.tags && post.tags.length > 0 && (
            <>
              <Tag className="w-4 h-4 ml-4 mr-1" />
              <span>{post.tags.join(', ')}</span>
            </>
          )}
        </div>
      </div>
    </article>
  );
};

export default BlogCard;